import { render, staticRenderFns } from "./ShopifyTooltip.vue?vue&type=template&id=a40402be&scoped=true&"
import script from "./ShopifyTooltip.vue?vue&type=script&lang=ts&"
export * from "./ShopifyTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./ShopifyTooltip.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ShopifyTooltip.vue?vue&type=style&index=1&id=a40402be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40402be",
  null
  
)

export default component.exports